module.exports = __webpack_public_path__ + "static/media/default.7d832c73.svg";